import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Box, Link } from "@material-ui/core";
import DataService from "../../../../Service";
import MaterialTable from "material-table";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Grid from "@material-ui/core/Grid";
import { Divider } from "@material-ui/core";
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  IconButton,
} from "@material-ui/core";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

function CancellationDetails() {
  const classes = useStyles();
  const [pgmCancellation, setPgmCancellation] = useState([]);
  const [cancellation360, setCancellation360] = useState([]);
  const [sessionCancellationTerm, setSessionCancellationTerm] = useState([]);
  const [assignmentName, setassignmentName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [coachingPgmPrice, setCoachingPgmPrice] = useState("");
  const [cancellationNotes, setCancellationNotes] = useState("");
  const [otherCancellationNotes, setOtherCancellationNotes] = useState("");

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  let urlElements = window.location.href.split('/');
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID
    }
    DataService.getDirectData(`/invoices/cancellation_details`, params).then((response) => {

      setassignmentName(response.assignment_name)
      setOrgName(response.organisation_name)
      setAdditionalNotes(response.additional_notes)
      setCancellationNotes(response.cancellation_notes)
      setOtherCancellationNotes(response.other_cancellation_reason || "")
      setPgmCancellation(response.pgm_cancellation_term)
      setSessionCancellationTerm(response.session_cancellation_term)
      setCancellation360(response.cancellation_term360)
      setLoading(false);
    })

      .catch((err) => { });
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true)
  }

  return (
    <div style={{ width: "100%" }}>
      <Box mb="15px">
        <Typography className={classes.title}>Cancellation Reason</Typography>
        <Typography className={classes.bodyText}>
          {cancellationNotes||"-"}
        </Typography>
      </Box>
      <Box mb="15px">
        <Typography className={classes.title}>Cancellation notes</Typography>
        <Typography className={classes.bodyText} style={{ maxWidth: 545 }}>
          {otherCancellationNotes||"-"}
        </Typography>
      </Box>

      <Box mb="15px">
        <Typography className={classes.title}>Additional notes</Typography>
        <Typography className={classes.bodyText} style={{ maxWidth: 545 }}>
          {additionalNotes||"-"}
        </Typography>
      </Box>
      <Link onClick={() => {
        setOpen(true)
      }}>
        <Typography
          variant="subtitle2"
          color="secondary"
          className={classes.title}
          style={{cursor:"pointer"}}
        >
          View Cancellation terms
        </Typography>
      </Link>
      <Dialog
        maxWidth={"xl"}
        style={{
          height: "100%",
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle id="customized-dialog-title">

          <IconButton
            className={classes.iconButton}
            onClick={handleClose}
            aria-label="menu"
          >
            <ArrowBackIcon />
          </IconButton>

          Cancellation terms
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "0px auto" }}>

          <div className={classes.formWrapper}>
            <Typography
              variant="subtitle2"
              color="secondary"
              className={classes.title}
            >
            </Typography>
            {/* <form onSubmit={handleSubmit}> */}
            <Grid
              container
              spacing={1}
              alignItems={"center"}
              justify={"flex-start"}
            >

              <React.Fragment>
                <Grid item xs={12}>
                  <Typography style={{fontWeight:"bold"}}>Program cancellation terms</Typography>
                  {pgmCancellation.length > 0 && pgmCancellation.map((item) => (
                    <ListItem disablePadding>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                  <Typography style={{fontWeight:"bold",marginTop:"0.5rem"}}>360 cancellation terms</Typography>
                  {cancellation360.length > 0 && cancellation360.map((item) => (
                    <ListItem disablePadding>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                  <Typography style={{fontWeight:"bold",marginTop:"0.5rem"}}>Session cancellation terms</Typography>
                  {sessionCancellationTerm.length > 0 && sessionCancellationTerm.map((item) => (
                    <ListItem disablePadding>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}

                </Grid>
              </React.Fragment>
            </Grid>

            <div className={classes.actionButtons}>

              <Button
                disableElevation
                disabled={loading}
                type="button"
                variant={"contained"}
                onClick={handleClose}
              >
                Close
              </Button>
            </div>

            {/* </form> */}
          </div>

        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CancellationDetails;

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 14,
    lineHeight: "24px",
    color: theme.palette.secondary.main,
    marginBottom: 16,
  },
  bodyText: { fontSize: 14, lineHeight: "24px", color: "#232323" },
}));
